<template>
  <b-container class="bv-example-row">
    <b-modal hide-footer
      id="modalPrevent"
      ref="myModalRef"
      title="Enter Details"
      @shown="clearName" 
      no-stacking
    >

    <div v-if="show">{{ status }}</div>
      <b-form @submit="onSubmit" @reset="onReset" >
      <b-form-group
        label="Enter purpose:"
      >
        <b-form-input
          type="text"
          v-model="form.purpose"
          required
          placeholder="Enter purpose" />
      </b-form-group>

      <b-form-group label="Your FrontendBranch:">
        <b-form-input
          type="text"
          v-model="form.FEBranch"
          required
          placeholder="Enter FrontendBranch" />
      </b-form-group>

      <b-form-group label="Your BackendBranch:" >
        <b-form-input
          type="text"
          v-model="form.BEBranch"
          required
          placeholder="Enter BackendBranch" />
      </b-form-group>

      <b-button type="submit"  variant="primary">Submit</b-button>
      <b-button type="reset"  variant="danger">Reset</b-button>
    </b-form>
    </b-modal>
    <b-row class="m-b10">
      <router-link class="col-md-3 app-link box-container" tag="a" to="/stacks">
        <h5 class="h3 text-mute">Available Stacks</h5>
        <h4>{{items1.length}}</h4>
      </router-link>
      <router-link class="col-md-3 app-link box-container" tag="a" to="/teams">
        <h5 class="h3 text-mute">Total Sqauds</h5>
        <h4>{{totalsquadcount}}</h4>
      </router-link>
      <router-link class="col-md-3 app-link box-container" tag="a" to="/stacks">
        <h5 class="h3 text-mute">Total Stacks</h5>
        <h4>{{totalstackcount}}</h4>
      </router-link>
    </b-row>
    <b-row class="m-b10">
      <b-col md="3" class="app-link box-container">
        <section class="header-card">
          <h4 class="card-title">Avaliable Stacks</h4>
          <p class="card-category">Here listed the stacks </p>
        </section>
        <b-table  striped class="hide-top-border app-normal-table " :items="items1" :fields="fields1" show-empty>
          <template slot="use" slot-scope="row">
            <b-button variant="success" size="sm"  @click="myRowClickHandler(row.item)" class="mr-1" 
            :disabled="$session.get('stackname') != ''" >
              Get Stack
            </b-button>
          </template>
        </b-table>
     </b-col>
      <b-col  class="box-card box-container">
        <section class="header-card">
        <h4 class="card-title">Current Stacks Usage</h4>
          <p class="card-category">Here listed the employee using the stack </p>
        </section>
        <b-table  striped 
            class="hide-top-border app-normal-table " 
            :items="unavaliableitems" 
            :fields="fieldsunavaliable" 
            show-empty>
          <template slot="stackname" slot-scope="row">
            <router-link tag="a" :to="{path: '/Dashboard/dashboardfulldetails', query: { purpose: unavaliableitems[row.index].purpose, employee: unavaliableitems[row.index].employeename, stackname: unavaliableitems[row.index].stackname}}" key="link_stackusage" >
              <span v-text="row.item.stackname"></span>
            </router-link>
          </template>
          <template slot="action" slot-scope="row">
            <b-button variant="success" size="sm"  value="" :disabled="$session.get('role') != 'admin' && $session.get('username') != row.item.employeename " @click="myRowClickHandlerFree(row.item)" class="mr-1">
              Free Stack
            </b-button>
          </template>
        </b-table>
      </b-col>
      
    </b-row>
    <b-row class="m-b10">
      <b-col md="5" class="box-card box-container">
        <section class="header-card">
        <h4 class="card-title">Stack used count</h4>
        </section>
        <canvas id="graph1" width="200" height="200"></canvas>
      </b-col>
      <b-col md="5" class="box-card box-container">
        <section class="header-card">
        <h4 class="card-title">Squad wise stack used count</h4>
      </section>
        <canvas id="graph2" width="200" height="200"></canvas>
      </b-col>
    </b-row>
  </b-container>
</template>

<script >
  import http from "../http-common";
  import { mapGetters, mapActions } from 'vuex'
  import Chart from "chart.js";
  export default {
    name: 'Dashboard',
    data() {
      return {
        user:{
          username:'',
          purpose:'',
          frontendBranch:'',
          backendBranch:'',
          stackname:''
        },
        userdata: {
          username: '',
          stackname: ''
        },
        items1: [],
        fields1: ['stackname','use'],
        unavaliableitems:[],
        fieldsunavaliable: [{ key: 'stackname', label: 'Stack Name', clickable:true },
          { key: 'employeename', label: 'Employee Name'},
          { key: 'purpose', label: 'Purpose' },
          { key: 'action', label: 'Action' }],
        totalstackentries: 0,
        currentPage:1,
        form: {
          purpose:'',
          FEBranch:'',
          BEBranch:''
        },
        status:'',
        show:false,
        totalsquadcount:0,
        totalstackcount:0,
        squadlist:[],
        stacklist:[],
        max1:0,
        max2:0,
        send_message: null,
        connected: false,
        stompvalue:''
      };
    },
    methods: {
        ...mapActions([
              'commitactivetab',
              'send_actions',
              'commitstackname'
            ]),
        setactivetab: function(value) {
            this.commitactivetab(value)
          },
        send() {
          var msg={message:"Get Stack:"+this.user['stackname'],url:"/topic/greetings"}
          this.send_actions(msg)
        },
        async myRowClickHandlerFree(record){
          if(this.$session.get("role")!="admin" && this.$session.get("stackname")==record['stackname']){
            await this.releasestack(this.$session.get("username"),record['stackname']);
            var send1={message:"Free Stack:"+record['stackname'],url:'/app/hello'}
            await this.send_actions(send1)
            
          }else{
            await this.releasestackbyadmin(record['stackname']);
            var send2={message:"Free Stack:"+record['stackname'],url:'/app/hello'}
            await this.send_actions(send2)
          }

          await this.getallstack()
          await this.getallsquad()
          await this.getstackusagebysquad()
          await this.retrieveUsedforgraph()
          await this.gettotalsquadentries()
          await this.gettotalstackentries()
          await this.retrieveUnAvaliable()
          await this.retrieveAvaliable()
          
        },
        async releasestack(username,stackname) {
            this.userdata['username']=username
            this.userdata['stackname']=stackname
            await http
            .post("/releasestack", this.userdata)
            .catch(e => {
              console.log(e);
            });
        },
        async releasestackbyadmin(stackname) {
            await http
            .post("/releasestackbyadmin", stackname)
            .catch(e => {
              console.log(e);
            });
        },
        async retrieveUsedforgraph() {
           await http
           .get("/getdistinctstackcount")
           .then(response => {
                for(var data in response.data){
                  this.datalabel=JSON.stringify(response.data[data][0])
                  this.datadata=response.data[data][1]
                }
                var names = response.data.map(function(item) {
                return item['0']
                });
                var dat = response.data.map(function(item) {
                  return item['1']
                });
                if(Math.max(...dat) %5==0){
                  this.max1=Math.max(...dat)+5
                }else{
                  this.max1=Math.max(...dat)+(5-Math.max(...dat)%5)
                }
                this.datadata=dat
                this.datalabel=names
                this.createChart(document.getElementById("graph1"))
              })
           .catch(e => {
             console.log(e);
           });
         },
        createChart(c) {
          new Chart(c, {
            type: "bar",
            data: {
              labels:this.datalabel,
              datasets: [
              {
                label: "# of time stack used",
                data: this.datadata,
                backgroundColor:"rgba(255, 99, 132, 0.2)",
                borderColor:"rgba(255,99,132,1)",
                borderWidth: 2
              }
              ]
            },
            options: {
              scales: {
                yAxes: [
                {
                  ticks: {
                    min: 0,
                    max: this.max1,
                    stepSize: 5,
                    beginAtZero: true

                  }
                }
                ]
              }
            }
          });
        },
        createmultibarChart(data){
           var ctx = document.getElementById("graph2").getContext("2d");
            new Chart(ctx, {
              type: 'bar',
              data: data,
              options: {
                barValueSpacing: 20,
                scales: {
                  yAxes: [{
                    ticks: {
                      min: 0,
                      max:this.max2,
                      stepSize: 5,
                    }
                  }]
                }
              }
            });
        },
        async onSubmit(evt) {
            evt.preventDefault()
            this.user['purpose'] = this.form.purpose
            this.user['frontendBranch'] = this.form.FEBranch
            this.user['backendBranch'] = this.form.BEBranch
            await this.getstack()
            
        },
        onReset(evt) {
          evt.preventDefault()
          this.form.purpose = '';
          this.form.FEBranch = '';
          this.form.BEBranch = '';
          this.status='';
        },
        clearName() {
            this.user['purpose'] = '';
            this.user['FEBranch'] = '';
            this.user['BEBranch'] = '';
        },
        handleOk(evt) {
          evt.preventDefault()
          if (!this.name) {
            alert('Please enter your name')
          } else {
            this.handleSubmit()
          }
        },
        handleSubmit() {
          this.clearName()
          this.$nextTick(() => {
            this.$refs.myModalRef.hide()
          })
        },
        myRowClickHandler(record) {
          this.user['stackname']=record['stackname'];
          this.$refs.myModalRef.show();
        },
        async retrieveAvaliable() {
            await http
            .get("/avaliable")
            .then(response => { 
              this.items1=response.data;
            })
            .catch(e => {
              console.log(e)
            });
        },
        async retrieveUnAvaliable() {
            await http
            .get("/unavaliable")
            .then(response => {
              this.unavaliableitems=response.data;
            })
            .catch(e => {
              console.log(e)
            });
        },
        async getstack(){
          await http
            .post("/getstack", this.user)
            .then(response => {
              if(response.data!="Done"){
                this.status=response.data
                this.show=true
              }else{
              this.$session.set('stackname',this.user['stackname'])
              this.commitstackname(this.user['stackname'])
              var send3="Get Stack:"+this.user['stackname']
              this.send(send3)
              this.form.purpose = '';
              this.form.FEBranch = '';
              this.form.BEBranch = '';
              this.$router.push({ path: '/stacks'})
              }
            })
            .catch(e => {
              console.log(e)
            });
            this.retrieveAvaliable()
        },
        async gettotalsquadentries(){
          await http
              .get("/squadscount")
              .then(response => {
                this.totalsquadcount=response.data
              })
            .catch(e => {
                console.log(e)
              });
        },
        async gettotalstackentries(){
          await http
              .get("/stackscount")
              .then(response => {
                this.totalstackcount=response.data
              })
            .catch(e => {
                console.log(e)
              });
        },
        async getstackusagebysquad() {
            await http
            .get("/getstackusagebysquad")
            .then(response => {
              var dataset=[]
              var color=["rgba(255, 99, 132, 0.2)","rgba(10, 99, 100, 0.2)","rgba(150, 100, 200, 0.2)","rgba(100, 150, 1, 0.2)","rgba(200, 50, 110, 0.2)","rgba(50, 300, 10, 0.2)"]
              for(var i=0;i<this.stacklist.length;i++){
                var jsonvar={
                  label:this.stacklist[i],
                  backgroundColor: color[i],
                  data: response.data.slice(i*this.totalsquadcount,(i*this.totalsquadcount)+this.totalsquadcount)
                }
                dataset.push(jsonvar)
              }
              var data = {
                labels: this.squadlist,
                datasets: dataset
              };
              if(Math.max(...response.data) %5==0){
                this.max2=Math.max(...response.data)+5
              }else{
                this.max2=Math.max(...response.data)+(5-Math.max(...response.data) %5)
              }
              this.createmultibarChart(data)
            })
            .catch(e => {
              console.log(e)
            });
        },
        async getallsquad() {
            await http
            .get("/squads")
            .then(response => {
              this.squadlist=response.data
            })
            .catch(e => {
              console.log(e)
            });
        },
        async getallstack() {
            await http
            .get("/stacks")
            .then(response => {
              this.stacklist=response.data
            })
            .catch(e => {
              console.log(e)
            });
        },
        async getstackusedname() {
            await http
            .post("/used",this.$session.get("username"))
            .then(response => {
              if(response.data[0]!=null){
                this.commitstackname(response.data[0]['stackname'])
                this.$session.set("stackname",response.data[0]['stackname'])
              }else{
                this.commitstackname("")
                this.$session.set("stackname","")
              }
              
            })
            .catch(e => {
              console.log(e)
            });
          },
    },
    created(){
      this.setactivetab(1)
      this.getallstack()
      this.getallsquad()
      this.getstackusagebysquad()
      this.retrieveUsedforgraph()
      this.gettotalsquadentries()
      this.gettotalstackentries()
      this.retrieveAvaliable()
      this.retrieveUnAvaliable()
      this.user['username']=this.$session.get('username')
    },
    computed: {
      ...mapGetters([
      'getreceived_messages_store',
      'getactivetab'
      ]),

    },
    watch: {
      getreceived_messages_store:async function (val){
        if(val.content_type=="stack_changes"){
          await this.getstackusedname()
          await this.getallstack()
          await this.getallsquad()
          await this.getstackusagebysquad()
          await this.retrieveUsedforgraph()
          await this.gettotalsquadentries()
          await this.gettotalstackentries()
          await this.retrieveUnAvaliable()
          await this.retrieveAvaliable()

        }
      }
    }
  }
</script>

<style>

.m-b10{
  margin-bottom: 15px;
}
.h3{
  font-size: 16px;
  color: #333;
  font-weight: 100;
}
.app-link{
  font-size: 16px;
  margin-right: 7px;
  color: #1dc7ea;
}
.box-card{
  font-size: 16px;
  margin-right: 7px;
  color: #1dc7ea;
}
.text-mute{
  color: #9a9a9a;
}

.app-link:hover{
  text-decoration: none;
  color: #1dc7ea;
}
.box-container{
  background-color: #fff;
  border-radius: 4px;
  padding: 14px 18px;
  border: 1px solid rgba(0,0,0,.125);
}
table{
  table-layout:fixed;
  text-align:center;
  vertical-align: middle;
  overflow: hidden; 
  word-wrap: break-word;
}
@media only screen and (max-width: 850px){
  .col1 {
    -ms-flex: 0 0 100%;
    -webkit-box-flex: 0;
    flex: 0 0 100%;
    max-width: 100%!important;}
    .col2 {
      -ms-flex: 0 0 100%;
      -webkit-box-flex: 0;
      flex: 0 0 100%;
      max-width: 100%!important;
    }
    .card {
      overflow-x: auto;
      display: block;
    }

  }
</style>
